import { queryClient } from '@app/configs/query';

import { ProcessField } from '@shared/types/process';
import { stringifyFieldDefaultValue } from '@shared/util/flowParseValue';

import { useQueryMutation } from './useQueryMutation';

import { useNavigate, useParams } from 'react-router-dom';

export function useProcessField(fieldIdProps?: string | null) {
    const { fieldId: fieldIdParams, processId } = useParams();
    const fieldId = fieldIdProps || fieldIdParams;

    const navigate = useNavigate();

    const editField = useQueryMutation<
        ProcessField & { isNotNavigateAfterSuccess?: boolean }
    >('flow/ServiceProcessFields/Update', 'put', {
        variablesFn(values) {
            return {
                ...values,
                options: JSON.stringify(values.options),
                defaultValue: stringifyFieldDefaultValue(values),
            } as unknown as ProcessField;
        },
        invalidateOnSuccess: [
            ['flow/ServiceProcessFields/GetAll'],
            ['flow/ServiceProcessFields/GetAllByServiceId'],
            [`flow/FlowDictionaries/ServiceProcessFields`],
            ['flow/Services/Get'],
            ['flow/Services/GetAll'],
            ['flow/ServiceProcessFlowGraph/GetFieldsByStage'],
        ],
        onSuccess({ variables }) {
            void queryClient.invalidateQueries({
                queryKey: [`flow/ServiceProcessFields/Get/${variables.id}`],
            });
            void queryClient.invalidateQueries({
                queryKey: ['flow/ServiceProcessFields/GetAllByServiceId'],
            });
            if (!variables.isNotNavigateAfterSuccess) {
                navigate(`../../../../${variables.serviceProcessId}/fields`, {
                    relative: 'path',
                });
            }
        },
    });

    const delField = useQueryMutation(
        'flow/ServiceProcessFields/Delete/' + fieldId,
        'delete',
        {
            invalidateOnSuccess: [
                ['flow/ServiceProcessFields/GetAll'],
                ['flow/ServiceProcessFields/GetAllByServiceId'],
                [`flow/FlowDictionaries/ServiceProcessFields`],
                ['flow/Services/Get'],
                ['flow/Services/GetAll'],
                ['flow/ServiceProcessFlowGraph/GetFieldsByStage'],
            ],
            onSuccess() {
                navigate('..');
            },
        },
    );

    const addField = useQueryMutation<ProcessField>(
        'flow/ServiceProcessFields/Create',
        'post',
        {
            // @ts-expect-error override
            variablesFn(values) {
                return {
                    ...values,
                    options: JSON.stringify(values.options),
                    serviceProcessId: processId,
                    defaultValue: stringifyFieldDefaultValue(values),
                };
            },
            invalidateOnSuccess: [
                ['flow/ServiceProcessFields/GetAll'],
                ['flow/ServiceProcessFields/GetAllByServiceId'],
                ['flow/FlowDictionaries/ServiceProcessFields'],
                ['flow/Services/Get'],
                ['flow/Services/GetAll'],
                ['flow/ServiceProcessFlowGraph/GetFieldsByStage'],
            ],
        },
    );

    return {
        fieldId: fieldId || '',
        editField,
        addField,
        delField,
    };
}
